export const getImageUrlWithSizing = (imgUrl, width, height) => {
  if (!imgUrl) {
    return null;
  }
  if (!width || !height) {
    return imgUrl;
  }
  return `${imgUrl}?w=${width}&h=${height}`;
};
